import { Component, Input, inject } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../../../model';
import { SanitizerService } from '../../../../../services/sanitizer.service';

@Component({
  selector: 'now-wbsuche-lib-zugangsinformationen',
  templateUrl: './zugangsinformationen.component.html',
  styleUrls: ['../keywords.scss'],
  imports: []
})
export class ZugangsinformationenComponent {
  private readonly sanitizerService = inject(SanitizerService);

  @Input()
  public termin!: BildungsangebotTerminDetail;

  sanitizeFunction(html?: string): string {
    return this.sanitizerService.sanitize(html);
  }

  computeTeilnehmer() {
    const min = this.termin.teilnehmerMin ?? 1;
    const max = this.termin.teilnehmerMax;
    if (!max) {
      return `mindestens ${min}`;
    }
    return `${min} - ${max}`;
  }
}
